//imported
import * as Path from "routes/paths";

const useModules = () => {
  let modules = [
    /******dashboard********** */
    {
      url: Path.dashboard,
      model_name: "dashboard",
      name: "Dashboard",
      icon: "mdi mdi-home menu-icon",
      dashboard_color: "bg-light",
      is_modules: false,
      is_dropdown: false,
      is_dashboard: false,
      is_permission: true,
      count: 0,
      sub_modules: {},
    },
    /******users********** */
    {
      url: Path.users,
      model_name: "user",
      name: "Users",
      sub_name_1: "Personal detail",
      sub_name_2: "Match preferences",
      icon: "mdi menu-arrow menu-icon",
      icon1: "mdi mdi-account-multiple menu-icon",
      dashboard_color: "bg-light",
      is_modules: true,
      is_permission: true,
      is_dropdown: true,
      is_dashboard: true,
      count: 0,
      sub_modules: {
        add: Path.user_add,
        edit: Path.user_edit,
        edit_form: Path.useredit,
        view: Path.user_view,
        view_form: Path.userview,
      },
      sub_modules_urls: {
        url_1: Path.users,
        url_2: Path.usermatches,
      },
    },
    /******coach********** */
    {
      url: Path.coach,
      model_name: "coach",
      name: "Coach",
      icon: "mdi mdi-account-multiple menu-icon",
      dashboard_color: "bg-light",
      is_modules: true,
      is_permission: true,
      is_dashboard: true,
      is_dropdown: false,
      count: 0,
      sub_modules: {
        add: Path.coach_add,
        edit: Path.coach_edit,
        edit_form: Path.coachedit,
        view: Path.coach_view,
        view_form: Path.coachview,
      },
    },

    /******feed-report********** */
    {
      url: Path.feed,
      model_name: "feed",
      name: "Feed Reports",
      icon: "mdi mdi-account-multiple menu-icon",
      dashboard_color: "bg-light",
      is_modules: true,
      is_permission: true,
      is_dashboard: true,
      is_dropdown: false,
      count: 0,
      // sub_modules: {
      //   add: Path.coach_add,
      //   edit: Path.coach_edit,
      //   edit_form: Path.coachedit,
      //   view: Path.coach_view,
      //   view_form: Path.coachview,
      // },
    },
    /******Transactions********** */
    {
      url: Path.transaction,
      model_name: "transaction",
      name: "Transactions",
      icon: "mdi mdi-credit-card menu-icon",
      dashboard_color: "bg-light",
      is_modules: true,
      is_permission: true,
      is_dashboard: false,
      is_dropdown: false,
      count: 0,
      sub_modules: {},
    },
    /******Manage Tennis Matches********** */
    {
      url: Path.match,
      model_name: "match",
      name: "Manage Tennis Match",
      icon: "mdi mdi-format-list-bulleted menu-icon",
      dashboard_color: "bg-light",
      is_modules: true,
      is_permission: true,
      is_dashboard: true,
      is_dropdown: false,
      count: 0,
      sub_modules: {
        view: Path.match_view,
        view_form: Path.matchview,
      },
    },
    /******Posts********** */
    {
      url: Path.post,
      model_name: "post",
      name: "Posts",
      icon: "mdi mdi-format-list-bulleted menu-icon",
      dashboard_color: "bg-light",
      is_modules: true,
      is_permission: true,
      is_dropdown: false,
      is_dashboard: false,
      count: 0,
      sub_modules: {
        add: Path.post_add,
        edit: Path.post_edit,
        edit_form: Path.postedit,
        view: Path.post_view,
        view_form: Path.postview,
      },
    },
    /******Categories********** */
    {
      url: Path.category,
      model_name: "category",
      name: "Categories",
      icon: "mdi mdi-format-list-bulleted menu-icon",
      dashboard_color: "bg-light",
      is_modules: true,
      is_permission: true,
      is_dashboard: true,
      is_dropdown: false,
      count: 0,
      sub_modules: {
        add: Path.category_add,
        edit: Path.category_edit,
        edit_form: Path.categoryedit,
        view: Path.category_view,
        view_form: Path.categoryview,
        add_sub: Path.subcategory_add,
        edit_sub: Path.subcategory_edit,
        edit_form_sub: Path.subcategoryedit,
        view_sub: Path.subcategory_view,
        view_form_sub: Path.subcategoryview,
        list_sub: Path.subcategory_list,
      },
    },
    /******SubCategories********** */
    {
      url: Path.subcategory_list,
      model_name: "subcategory",
      name: "SubCategories",
      icon: "mdi mdi-format-list-bulleted menu-icon",
      dashboard_color: "bg-light",
      is_modules: true,
      is_permission: false,
      is_dashboard: false,
      is_dropdown: false,
      count: 0,
      sub_modules: {
        add: Path.subcategory_add,
        edit: Path.subcategory_edit,
        edit_form: Path.subcategoryedit,
        view: Path.subcategory_view,
        view_form: Path.subcategoryview,
      },
    },
    /******Reports********** */
    {
      url: Path.report_list,
      model_name: "reports",
      name: "Reports",
      icon: "mdi mdi-format-list-bulleted menu-icon",
      dashboard_color: "bg-light",
      is_modules: true,
      is_permission: true,
      is_dashboard: false,
      is_dropdown: false,
      count: 0,
      sub_modules: {},
    },

    /******Support********** */
    {
      url: Path.support_list,
      model_name: "support",
      name: "Support",
      icon: "mdi mdi-format-list-bulleted menu-icon",
      dashboard_color: "bg-light",
      is_modules: true,
      is_permission: true,
      is_dashboard: false,
      is_dropdown: false,
      count: 0,
      sub_modules: {},
    },
    /******Earning Management********** */
    {
      url: Path.earning,
      model_name: "earning",
      name: "Earning Management",
      icon: "mdi mdi-wallet menu-icon",
      dashboard_color: "bg-light",
      is_modules: true,
      is_permission: true,
      is_dropdown: false,
      is_dashboard: true,
      count: 0,
      sub_modules: {
        view: Path.earning_view,
        view_form: Path.earningview,
      },
    },
    /******Manage Payouts********* */
    // {
    //     url : Path.manage_payouts,
    //     model_name: 'manage_payouts',
    //     name : 'Manage Payouts',
    //     icon : 'mdi mdi-wallet menu-icon',
    //     dashboard_color : 'bg-light',
    //     is_modules:true,
    //     is_permission:true,
    //     is_dashboard:true,
    //     count:0,
    //     sub_modules : {
    //         view : Path.manage_payouts_view,
    //         view_form : Path.manage_payoutsview,
    //     }
    // },
    /******Promocode********** */
    {
      url: Path.promocode,
      model_name: "promocode",
      name: "Promocode",
      icon: "mdi mdi-format-list-bulleted menu-icon",
      dashboard_color: "bg-light",
      is_modules: true,
      is_permission: true,
      is_dashboard: false,
      is_dropdown: false,
      count: 0,
      sub_modules: {
        add: Path.promocode_add,
        edit: Path.promocode_edit,
        edit_form: Path.promocodeedit,
        view: Path.promocode_view,
        view_form: Path.promocodeview,
      },
    },
    /******Promocode********** */
    {
      url: Path.user_promocode,
      model_name: "user_promocode",
      name: "User Promo's",
      icon: "mdi mdi-format-list-bulleted menu-icon",
      dashboard_color: "bg-light",
      is_modules: true,
      is_permission: true,
      is_dashboard: false,
      is_dropdown: false,
      count: 0,
      sub_modules: {
        view_form: Path.userpromocodeview,
        view: Path.user_promocode_view,
      },
    },
    /******System Access********* */
    {
      url: Path.system_access,
      model_name: "system_access",
      name: "System Access",
      icon: "mdi mdi-account-multiple menu-icon",
      dashboard_color: "bg-light",
      is_modules: true,
      is_permission: true,
      is_dashboard: false,
      is_dropdown: false,
      count: 0,
      sub_modules: {
        add: Path.system_access_add,
        edit: Path.system_access_edit,
        edit_form: Path.system_accessedit,
        view: Path.system_accessview,
        view_form: Path.system_access_view,
      },
    },
    /******FAQ********* */
    {
      url: Path.faq,
      model_name: "faq",
      name: "FAQ",
      icon: "mdi mdi-format-list-bulleted menu-icon",
      dashboard_color: "bg-light",
      is_modules: true,
      is_permission: true,
      is_dashboard: false,
      is_dropdown: false,
      count: 0,
      sub_modules: {
        add: Path.faq_form,
        edit: Path.faqform,
      },
    },
    /******Basic setting********* */
    {
      url: Path.basic_setting,
      model_name: "basic_setting",
      name: "Basic Setting",
      icon: "mdi mdi-format-list-bulleted menu-icon",
      dashboard_color: "bg-light",
      is_modules: false,
      is_permission: true,
      is_dropdown: false,
      is_dashboard: false,
      count: 0,
      sub_modules: {},
    },
    /******Content Pages********* */
    {
      url: Path.cms,
      model_name: "cms",
      name: "Content Pages",
      icon: "mdi mdi-table-large menu-icon",
      dashboard_color: "bg-light",
      is_modules: true,
      is_permission: true,
      is_dashboard: false,
      is_dropdown: false,
      count: 0,
      sub_modules: {
        add: Path.cmsform,
        edit: Path.cms_form,
      },
    },
    /******Configuration********* */
    {
      url: Path.configuration_add,
      model_name: "configuration",
      name: "Configuration",
      icon: "mdi mdi-settings menu-icon",
      dashboard_color: "bg-light",
      is_modules: false,
      is_permission: true,
      is_dropdown: false,
      is_dashboard: false,
      count: 0,
      sub_modules: {},
    },
  ];
  return modules;
};

export { useModules };
